import { Injectable } from '@angular/core';
import { getDocument, getWindow } from 'ssr-window';
import { WindowExtension } from '../api/window-extension';

@Injectable({
    providedIn: 'root'
})
export class RokezzzWindowService {
    public getWindowExtension(): WindowExtension {
        return getWindow();
    }

    public getDocument(): Document {
        return getDocument();
    }
}
